import brakes from '~/assets/icons/brakes.svg';
import engine from '~/assets/icons/engine_2.svg';
import exhaust from '~/assets/icons/exhaust.svg';
import radiator from '~/assets/icons/radiator.svg';
import settings from '~/assets/icons/settings.svg';
import starter from '~/assets/icons/starter.svg';
import suspension from '~/assets/icons/suspension.svg';
import tires from '~/assets/icons/tires_2.svg';
import turbo from '~/assets/icons/turbo.svg';
import { TechTuningCategory, TechTuningRarity } from '~/shared';

export const TuningCategoryIcons: Record<TechTuningCategory, string> = {
	[TechTuningCategory.SETTINGS]: settings,
	[TechTuningCategory.ENGINE]: engine,
	[TechTuningCategory.TURBO]: turbo,
	[TechTuningCategory.EXHAUST]: exhaust,
	[TechTuningCategory.RADIATOR]: radiator,
	[TechTuningCategory.STARTER]: starter,
	[TechTuningCategory.BRAKES]: brakes,
	[TechTuningCategory.SUSPENSION]: suspension,
	[TechTuningCategory.TIRES]: tires,
};

export const TuningRarityColors: Record<TechTuningRarity, string> = {
	[TechTuningRarity.COMMON]: '#3BB200',
	[TechTuningRarity.UNCOMMON]: '#2D70D9',
	[TechTuningRarity.RARE]: '#A200FF',
	[TechTuningRarity.EPIC]: '#E39B00',
	[TechTuningRarity.LEGENDARY]: '#FF0013',
};
